module.exports = __webpack_public_path__ + "img/info.3fbcae00.svg";